export default __webpack_public_path__ + "static/media/Flag_of_Sudan.d94252fd.svg";